import { apiClient } from '@/lib/api-client';
import {
    SignupRequest,
    SignupResponse,
    LoginRequest,
    LoginResponse,
    VerifyOTPRequest,
    ResendOTPRequest,
    ResendOTPResponse,
    VerifyOTPResponse,
    AcceptInviteRequest,
    AcceptInviteResponse,
    ForgotPasswordRequest,
    ForgotPasswordResponse,
    ResetPasswordRequest,
    ResetPasswordResponse
} from '@/types/api';
import { tokenStorage } from '@/utils/token-storage';

export const authApi = {
    // Signup endpoint
    signup: async (data: SignupRequest): Promise<SignupResponse> => {
        // Remove confirmPassword from the request as it's only for client-side validation
        const { agreeToTerms, ...signupData } = data;

        return apiClient.post<SignupResponse>('/auth/signup', signupData);
    },

    // Login endpoint
    login: async (data: LoginRequest): Promise<LoginResponse> => {
        return apiClient.post<LoginResponse>('/auth/login', data);
    },

    // Logout endpoint
    logout: async (): Promise<void> => {
        const refreshToken = tokenStorage.getRefreshToken();
        if (refreshToken) {
            return apiClient.post<void>('/auth/logout', { refreshToken });
        }
        return apiClient.post<void>('/auth/logout');
    },

    // Refresh token endpoint
    refreshToken: async (): Promise<{ access_token: string; refresh_token: string }> => {
        const refreshToken = tokenStorage.getRefreshToken();
        if (!refreshToken) {
            throw new Error('No refresh token available');
        }

        return apiClient.post<{ access_token: string; refresh_token: string }>('/auth/refresh', {
            refreshToken
        });
    },

    // OTP Verification endpoint
    verifyOTP: async (data: VerifyOTPRequest): Promise<VerifyOTPResponse> => {
        return apiClient.post<VerifyOTPResponse>('/auth/verify-email', data);
    },

    // Resend OTP endpoint
    resendOTP: async (data: ResendOTPRequest): Promise<ResendOTPResponse> => {
        return apiClient.post<ResendOTPResponse>('/auth/resend-otp', data);
    },

    // Accept Invite endpoint
    acceptInvite: async (data: AcceptInviteRequest): Promise<AcceptInviteResponse> => {
        return apiClient.post<AcceptInviteResponse>('/auth/accept-invite', data);
    },

    // Forgot Password endpoint
    forgotPassword: async (data: ForgotPasswordRequest): Promise<ForgotPasswordResponse> => {
        return apiClient.post<ForgotPasswordResponse>('/auth/forgot-password', data);
    },

    // Reset Password endpoint
    resetPassword: async (data: ResetPasswordRequest): Promise<ResetPasswordResponse> => {
        return apiClient.post<ResetPasswordResponse>('/auth/reset-password', data);
    },
};
